import { Component, ElementRef, HostListener, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { PharmacyService } from '../../../../../services/pharmacy/pharmacy.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { dateRangeValidator } from '../../../../admin-dashboard-component/pharmacies/admin-pharmacies-list/filter/utils/today';
import { PharmacyFilters } from '../../../../../services/pharmacy/pharmacy.model';
import { LookupVTO } from '../../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-filter',
  imports: [ReactiveFormsModule, FormsModule],
  templateUrl: './filter.html',
  styleUrl: './filter.scss',
})
export class Filter {
  private el = inject(ElementRef);

  private locale = inject(LOCALE_ID);

  showStatusDropdown = signal<boolean>(false);
  selectedStatusIds = signal<number[] | undefined>([]);

  filterForm = new FormGroup(
    {
      statusId: new FormControl<number[] | undefined>(undefined),
      lastModifiedOnFrom: new FormControl<string>(''),
      lastModifiedOnTo: new FormControl<string>(''),
    },
    {
      validators: [dateRangeValidator('lastModifiedOnFrom', 'lastModifiedOnTo')],
    },
  );

  filters = input.required<PharmacyFilters>();
  statuses = input.required<LookupVTO[]>();

  toggleSortOrder = output();
  resetFilters = output();
  applyFilters = output<{
    lastModifiedOnFrom?: string;
    lastModifiedOnTo?: string;
    statusIds?: number[];
  }>();

  ngOnInit(): void {
    this.filterForm.get('statusId')!.valueChanges.subscribe((statusId) => {
      // console.log('statusId:', statusId);
      // this.statusChanged.emit(statusId ?? undefined);
    });

    // const user_id = this.userMgt.getUserId();
    // this.userId.set(user_id!);
  }

  // onCancelDropDown() {
  //   this.activeDropDown.set(false);
  // }
  onToggleSortOrder() {
    this.toggleSortOrder.emit();
  }
  onResetFilters() {
    this.resetFilters.emit();
    this.filterForm.reset();
    this.selectedStatusIds.set([]);
  }
  onApplyFilters() {
    console.log('this filter form', this.filterForm);
    if (this.filterForm.invalid) {
      this.filterForm.markAllAsTouched();
      return;
    }

    const { lastModifiedOnFrom, lastModifiedOnTo } = this.filterForm.value;

    this.applyFilters.emit({
      lastModifiedOnFrom: lastModifiedOnFrom || undefined,
      lastModifiedOnTo: lastModifiedOnTo || undefined,
      statusIds: this.selectedStatusIds(),
    });
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }

  // STATUS DROP DOWN
  toggleStatusDropdown() {
    this.showStatusDropdown.set(!this.showStatusDropdown());
  }

  toggleStatus(id: number | undefined) {
    if (id === undefined) {
      this.selectedStatusIds.set([]);
      return;
    }
    const current = this.selectedStatusIds() ?? [];
    const index = current.indexOf(id);
    if (index === -1) {
      this.selectedStatusIds.set([...current, id]);
    } else {
      this.selectedStatusIds.set(current.filter((existingId) => existingId !== id));
    }
  }

  isStatusSelected(id: number | undefined): boolean {
    if (id === undefined) return (this.selectedStatusIds() ?? []).length === 0;
    return this.selectedStatusIds()?.includes(id) ?? false;
  }
  closeStatusDropdown() {
    this.showStatusDropdown.set(false);
  }

  today(): string {
    return new Date().toISOString().split('T')[0]; // "2025-02-22"
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdown = this.el.nativeElement.querySelector('.status-dropdown-container');
    if (dropdown && !dropdown.contains(event.target)) {
      this.closeStatusDropdown();
    }
  }
}
